module.exports = __webpack_public_path__ + "static/media/15UN-Habitat6.c950164e.jpg";